import { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { SidebarAdmin } from "../components";
import { sideBarInvestorData } from "../utils";
import InvestorNavbar from "../components/Investor/InvestorNavbar";
import InvestorPortalCapabilityGate from "../components/Investor/InvestorPortalCapabilityGate";
import InvestPathCapabilityGuard from "../components/Investor/InvestPathCapabilityGuard";
import { OnboardingTourHost } from "../components/Common/OnboardingTour";
import { usePublicInvestorCompany } from "../hooks/usePublicInvestorCompany";
import { selectCurrentCoopData } from "../store/auth/index";
import { useCompanyCapabilities } from "../hooks/useCompanyCapabilities";
import { filterInvestorSidebarByCapabilities } from "../utils/investorPortalRouteCapabilities";
import { InvestorContentFrame } from "../components/Investor/layout/InvestorLayoutPrimitives";

const FOCUSED_ONBOARDING_PREFIX = "/invest/onboarding";

export default function InvestorLayout({ children, LayoutClassName }) {
  const [hideSider, setHideSider] = useState(false);
  const { pathname } = useLocation();
  const focusedOnboarding = pathname.startsWith(FOCUSED_ONBOARDING_PREFIX);
  usePublicInvestorCompany();
  const coopData = useSelector(selectCurrentCoopData);
  const caps = useCompanyCapabilities();
  const filteredSidebar = useMemo(
    () => filterInvestorSidebarByCapabilities(sideBarInvestorData, caps),
    [caps]
  );

  const companyName = coopData?.company_name || coopData?.name;
  const companyLogo = coopData?.logo_url;

  return (
    <SideBarStyle $focused={focusedOnboarding}>
      {!focusedOnboarding ? (
        <SidebarAdmin
          hideSider={hideSider}
          setHideSider={setHideSider}
          sideBarData={filteredSidebar}
          companyNameOverride={companyName}
          companyLogoOverride={companyLogo}
        />
      ) : null}

      <main
        id="main"
        className={`main ${focusedOnboarding ? "main--focused-onboarding" : ""} ${LayoutClassName || "bg-gary2"}`}
      >
        <div className="w-100">
          <InvestorNavbar
            setHideSider={setHideSider}
            hideSider={hideSider}
            focusedOnboarding={focusedOnboarding}
          />
        </div>

        {focusedOnboarding ? (
          <div className="maincontent maincontent--focused-onboarding">
            <InvestorPortalCapabilityGate>
              <InvestPathCapabilityGuard>{children}</InvestPathCapabilityGuard>
            </InvestorPortalCapabilityGate>
          </div>
        ) : (
          <InvestorContentFrame className="maincontent">
            <InvestorPortalCapabilityGate>
              <InvestPathCapabilityGuard>{children}</InvestPathCapabilityGuard>
            </InvestorPortalCapabilityGate>
          </InvestorContentFrame>
        )}
      </main>
      {!focusedOnboarding ? <OnboardingTourHost role="investor" /> : null}
    </SideBarStyle>
  );
}

const SideBarStyle = styled.div`
  .main {
    min-height: 100vh;
    margin-left: 280px;
  }

  .main--focused-onboarding {
    margin-left: 0 !important;
    width: 100%;
  }

  .maincontent--focused-onboarding {
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 1rem 1rem 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .maincontent--focused-onboarding > * {
    width: 100%;
    max-width: 680px;
  }

  #main {
    transition: all 0.3s;
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
  }

  @media (max-width: 1199px) {
    #main {
      margin-left: 0;
    }
  }
`;
